import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';

import { TextField, TextFieldProps } from '@mui/material';

type CustomTextFieldProps<T extends FieldValues> = TextFieldProps & {
  name: Path<T>;
  type?: string;
  helperText?: string;
};

const CustomTextField = <T extends FieldValues>({
  name,
  type,
  helperText,
  ...other
}: CustomTextFieldProps<T>) => {
  const { control } = useFormContext<T>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          error={!!error}
          helperText={error ? error.message : helperText}
          {...other}
        />
      )}
    />
  );
};

export default CustomTextField;
